<template>
  <div id="about" class="container-fluid">
    <div class="skg-wording">
      <h1 class="text-center padding-div">About Us</h1>
      <div class="row pt-1">
        <div class="col-12 col-lg-6">
          <h5 class="p-3">
            <p>
              At SKG Construction we have been providing full-service building
              and remodeling services to residential, agricultural, and
              commercial customers throughout Malheur County, Oregon for over
              {{ years }} years.
            </p>
            <p>
              Owner Steve Glenn grew up here, as well as the 3 generations
              before him. He has assembled a small but effective crew lead by
              his foreman Mike and son, Seth Glenn. We live and respect the farm
              lifestyle and believe in hard, honest work.
            </p>
            <p>
              Quality craftsmanship, strong teamwork, vigorous work ethic, and
              outstanding customer service are pillars of our company, as well
              as having a sense of humor!
            </p>
            <p>
              We are a local, small business and hope that you will trust us for
              your construction needs.
            </p>
          </h5>
        </div>
        <div class="col-12 col-lg-6 zero-padding">
          <img
            src="../assets/family_picture.jpg"
            class="img-fluid"
            alt="Family picture of Steve, Kathy, and Seth"
          />
        </div>
      </div>
    </div>
    <div class="div-hr-padding">
      <hr class="div-hr" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: new Date().getFullYear() - 1996,
    };
  },
};
</script>

<style>
.skg-wording {
  color: rgb(85, 78, 78);
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.img-fluid {
  max-width: 100%;
  min-width: 100%;
  height: auto;
}
.padding-div {
  padding-top: 4rem;
}
.div-hr {
  border-top: 0.05rem solid rgb(29, 29, 29);
  width: 70%;
}
.div-hr-padding {
  padding-top: 2%;
}
.zero-padding {
  padding-left: 0;
  padding-right: 0;
}
</style>